export default __webpack_public_path__ + "static/media/cross-platform.95fdd34b.png";